module.exports = {"StatusCode":200,"Payload":"[{\"Availability\":\"AVAILABLE\"}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/searchDomainAvailability.json
// module id = QPU4
// module chunks = 0